<template>
  <div class="card">
    <div class="card-left">
      <md-card
        md-with-hover
        style="
          width: 590px;
          height: 720px;
          border-radius: 18px;
          margin-bottom: 20px;
        "
      >
        <md-card-header style="border-bottom: 1px solid #eee">
          <div class="md-title">
            <h3 style="text-align: left">
              <b style="color: #ff5252">优惠名额 </b>入学报名动态
              <a
                href="javascript:void(0)"
                onclick="ydtopenchat();return false;"
              >
                <md-button
                  class="md-raised md-accent"
                  style="float: right; width: 200px"
                  >立即报名</md-button
                ></a
              >
            </h3>
          </div>
        </md-card-header>
        <md-card-content>
          <div style="width: 100%; height: 13px"></div>
          <van-notice-bar left-icon="fire" :scrollable="false">
            <van-swipe
              vertical
              class="notice-swipe"
              :autoplay="4000"
              :show-indicators="false"
            >
              <van-swipe-item
                >唐诗*<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生24人 <b class="b">仅剩2人</b></van-swipe-item
              >
              <van-swipe-item
                >王一*<b class="b"></b>精品咖啡饮品班<b class="b"></b
                >计划招生20人 <b class="b">仅剩7人</b></van-swipe-item
              >
              <van-swipe-item
                >刘韩*<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生24人 <b class="b">仅剩3人</b></van-swipe-item
              >
              <van-swipe-item
                >黄晓*<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生21人 <b class="b">仅剩3人</b></van-swipe-item
              >
            </van-swipe>
          </van-notice-bar>
          <van-notice-bar left-icon="fire" :scrollable="false">
            <van-swipe
              vertical
              class="notice-swipe"
              :autoplay="4000"
              :show-indicators="false"
            >
              <van-swipe-item
                >杜茹*<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生24人 <b class="b">仅剩4人</b></van-swipe-item
              >
              <van-swipe-item
                >白恪*<b class="b"></b>精品咖啡饮品班<b class="b"></b
                >计划招生20人 <b class="b">仅剩6人</b></van-swipe-item
              >
              <van-swipe-item
                >王晓*<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生29人 <b class="b">仅剩6人</b></van-swipe-item
              >
              <van-swipe-item
                >李屹*<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生21人 <b class="b">仅剩5人</b></van-swipe-item
              >
            </van-swipe>
          </van-notice-bar>
          <van-notice-bar left-icon="fire" :scrollable="false">
            <van-swipe
              vertical
              class="notice-swipe"
              :autoplay="4000"
              :show-indicators="false"
            >
              <van-swipe-item
                >郭襄*<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生24人 <b class="b">仅剩5人</b></van-swipe-item
              >
              <van-swipe-item
                >周擎*<b class="b"></b>精品咖啡饮品班<b class="b"></b
                >计划招生23人 <b class="b">仅剩4人</b></van-swipe-item
              >
              <van-swipe-item
                >城易*<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生24人 <b class="b">仅剩3人</b></van-swipe-item
              >
              <van-swipe-item
                >代逝*<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生28人 <b class="b">仅剩5人</b></van-swipe-item
              >
            </van-swipe>
          </van-notice-bar>
          <van-notice-bar left-icon="fire" :scrollable="false">
            <van-swipe
              vertical
              class="notice-swipe"
              :autoplay="4000"
              :show-indicators="false"
            >
              <van-swipe-item
                >毕*呢<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生24人 <b class="b">仅剩7人</b></van-swipe-item
              >
              <van-swipe-item
                >玉*奇<b class="b"></b>精品咖啡饮品班<b class="b"></b
                >计划招生22人 <b class="b">仅剩6人</b></van-swipe-item
              >
              <van-swipe-item
                >李*名<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生24人 <b class="b">仅剩2人</b></van-swipe-item
              >
              <van-swipe-item
                >江*丝<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生19人 <b class="b">仅剩5人</b></van-swipe-item
              >
            </van-swipe>
          </van-notice-bar>
          <van-notice-bar left-icon="fire" :scrollable="false">
            <van-swipe
              vertical
              class="notice-swipe"
              :autoplay="4000"
              :show-indicators="false"
            >
              <van-swipe-item
                >*念波<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生24人 <b class="b">仅剩7人</b></van-swipe-item
              >
              <van-swipe-item
                >*凡梦<b class="b"></b>精品咖啡饮品班<b class="b"></b
                >计划招生22人 <b class="b">仅剩6人</b></van-swipe-item
              >
              <van-swipe-item
                >*小玉<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生24人 <b class="b">仅剩2人</b></van-swipe-item
              >
              <van-swipe-item
                >*向彤<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生19人 <b class="b">仅剩5人</b></van-swipe-item
              >
            </van-swipe>
          </van-notice-bar>
          <van-notice-bar left-icon="fire" :scrollable="false">
            <van-swipe
              vertical
              class="notice-swipe"
              :autoplay="4000"
              :show-indicators="false"
            >
              <van-swipe-item
                >齐柏*<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生24人 <b class="b">仅剩7人</b></van-swipe-item
              >
              <van-swipe-item
                >苏小*<b class="b"></b>精品咖啡饮品班<b class="b"></b
                >计划招生22人 <b class="b">仅剩6人</b></van-swipe-item
              >
              <van-swipe-item
                >白晰*<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生24人 <b class="b">仅剩2人</b></van-swipe-item
              >
              <van-swipe-item
                >江合*<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生19人 <b class="b">仅剩5人</b></van-swipe-item
              >
            </van-swipe>
          </van-notice-bar>
          <van-notice-bar left-icon="fire" :scrollable="false">
            <van-swipe
              vertical
              class="notice-swipe"
              :autoplay="4000"
              :show-indicators="false"
            >
              <van-swipe-item
                >*传友<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生13人 <b class="b">仅剩7人</b></van-swipe-item
              >
              <van-swipe-item
                >*兴权<b class="b"></b>精品咖啡饮品班<b class="b"></b
                >计划招生12人 <b class="b">仅剩6人</b></van-swipe-item
              >
              <van-swipe-item
                >*品涵<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生24人 <b class="b">仅剩2人</b></van-swipe-item
              >
              <van-swipe-item
                >*天洋<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生29人 <b class="b">仅剩5人</b></van-swipe-item
              >
            </van-swipe>
          </van-notice-bar>
          <van-notice-bar left-icon="fire" :scrollable="false">
            <van-swipe
              vertical
              class="notice-swipe"
              :autoplay="4000"
              :show-indicators="false"
            >
              <van-swipe-item
                >王*恒<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生37人 <b class="b">仅剩7人</b></van-swipe-item
              >
              <van-swipe-item
                >周*丽<b class="b"></b>精品咖啡饮品班<b class="b"></b
                >计划招生23人 <b class="b">仅剩6人</b></van-swipe-item
              >
              <van-swipe-item
                >夏*燕<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生32人 <b class="b">仅剩2人</b></van-swipe-item
              >
              <van-swipe-item
                >黄*夏<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生17人 <b class="b">仅剩5人</b></van-swipe-item
              >
            </van-swipe>
          </van-notice-bar>
          <van-notice-bar left-icon="fire" :scrollable="false">
            <van-swipe
              vertical
              class="notice-swipe"
              :autoplay="4000"
              :show-indicators="false"
            >
              <van-swipe-item
                >*宥玺<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生14人 <b class="b">仅剩7人</b></van-swipe-item
              >
              <van-swipe-item
                >*晨鑫<b class="b"></b>精品咖啡饮品班<b class="b"></b
                >计划招生13人 <b class="b">仅剩3人</b></van-swipe-item
              >
              <van-swipe-item
                >*文浩<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生16人 <b class="b">仅剩2人</b></van-swipe-item
              >
              <van-swipe-item
                >*恒越<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生11人 <b class="b">仅剩5人</b></van-swipe-item
              >
            </van-swipe>
          </van-notice-bar>
          <van-notice-bar left-icon="fire" :scrollable="false">
            <van-swipe
              vertical
              class="notice-swipe"
              :autoplay="4000"
              :show-indicators="false"
            >
              <van-swipe-item
                >何*玲<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生11人 <b class="b">仅剩7人</b></van-swipe-item
              >
              <van-swipe-item
                >柳*妮<b class="b"></b>精品咖啡饮品班<b class="b"></b
                >计划招生18人 <b class="b">仅剩6人</b></van-swipe-item
              >
              <van-swipe-item
                >刘*未<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生14人 <b class="b">仅剩2人</b></van-swipe-item
              >
              <van-swipe-item
                >江*娇<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生29人 <b class="b">仅剩1人</b></van-swipe-item
              >
            </van-swipe>
          </van-notice-bar>
          <van-notice-bar left-icon="fire" :scrollable="false">
            <van-swipe
              vertical
              class="notice-swipe"
              :autoplay="4000"
              :show-indicators="false"
            >
              <van-swipe-item
                >*晨鑫<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生24人 <b class="b">仅剩7人</b></van-swipe-item
              >
              <van-swipe-item
                >*智浩<b class="b"></b>精品咖啡饮品班<b class="b"></b
                >计划招生22人 <b class="b">仅剩6人</b></van-swipe-item
              >
              <van-swipe-item
                >*景泽<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生24人 <b class="b">仅剩2人</b></van-swipe-item
              >
              <van-swipe-item
                >*晨鑫<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生19人 <b class="b">仅剩5人</b></van-swipe-item
              >
            </van-swipe>
          </van-notice-bar>
          <van-notice-bar left-icon="fire" :scrollable="false">
            <van-swipe
              vertical
              class="notice-swipe"
              :autoplay="4000"
              :show-indicators="false"
            >
              <van-swipe-item
                >*惜文<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生24人 <b class="b">仅剩7人</b></van-swipe-item
              >
              <van-swipe-item
                >*香寒<b class="b"></b>精品咖啡饮品班<b class="b"></b
                >计划招生22人 <b class="b">仅剩6人</b></van-swipe-item
              >
              <van-swipe-item
                >*恒越<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生24人 <b class="b">仅剩2人</b></van-swipe-item
              >
              <van-swipe-item
                >*文浩<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生19人 <b class="b">仅剩5人</b></van-swipe-item
              >
            </van-swipe>
          </van-notice-bar>
          <van-notice-bar left-icon="fire" :scrollable="false">
            <van-swipe
              vertical
              class="notice-swipe"
              :autoplay="4000"
              :show-indicators="false"
            >
              <van-swipe-item
                >何*玲<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生11人 <b class="b">仅剩7人</b></van-swipe-item
              >
              <van-swipe-item
                >柳*妮<b class="b"></b>精品咖啡饮品班<b class="b"></b
                >计划招生18人 <b class="b">仅剩6人</b></van-swipe-item
              >
              <van-swipe-item
                >刘*未<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生14人 <b class="b">仅剩2人</b></van-swipe-item
              >
              <van-swipe-item
                >江*娇<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生29人 <b class="b">仅剩1人</b></van-swipe-item
              >
            </van-swipe>
          </van-notice-bar>
          <van-notice-bar left-icon="fire" :scrollable="false">
            <van-swipe
              vertical
              class="notice-swipe"
              :autoplay="4000"
              :show-indicators="false"
            >
              <van-swipe-item
                >*沛菡<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生14人 <b class="b">仅剩2人</b></van-swipe-item
              >
              <van-swipe-item
                >*傲珊<b class="b"></b>精品咖啡饮品班<b class="b"></b
                >计划招生32人 <b class="b">仅剩6人</b></van-swipe-item
              >
              <van-swipe-item
                >*曼文<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生17人 <b class="b">仅剩1人</b></van-swipe-item
              >
              <van-swipe-item
                >*乐菱<b class="b"></b>烘焙甜点精英班<b class="b"></b
                >计划招生19人 <b class="b">仅剩5人</b></van-swipe-item
              >
            </van-swipe>
          </van-notice-bar>
        </md-card-content>
        <div class="card-endtime">
          <h1>
            <van-count-down
              millisecond
              :time="time"
              format="报名剩余时间 mm:ss"
            />
          </h1>
        </div>
      </md-card>
    </div>
    <div class="card-right">
      <md-card
        md-with-hover
        style="
          width: 590px;
          height: 350px;
          border-radius: 18px;
          margin-bottom: 20px;
        "
      >
        <md-card-header>
          <div class="md-title">
            <h3 style="text-align: left">
              火热报名现场
              <a href="javascript:void(0)" onclick="ydtopenchat();return false;"
                ><md-button
                  class="md-raised md-accent"
                  style="float: right; width: 200px"
                  >立即报名</md-button
                ></a
              >
            </h3>
          </div>
        </md-card-header>
        <el-carousel height="278px" :autoplay="false">
          <el-carousel-item v-for="banner in cardList1" :key="banner.index">
            <img
              :src="banner"
              style="
                width: 100%;
                height: 100%;
                border-bottom-left-radius: 18px;
                border-bottom-right-radius: 18px;
              "
            />
          </el-carousel-item>
        </el-carousel>
      </md-card>
      <md-card
        md-with-hover
        style="
          width: 590px;
          border-radius: 18px;
          height: 350px;
          margin-bottom: 20px;
        "
      >
        <md-card-header>
          <div class="md-title">
            <h3 style="text-align: left">
              学员到校参观
              <a
                href="javascript:void(0)"
                onclick="ydtopenchat();return false;"
              >
                <md-button
                  class="md-raised md-accent"
                  style="float: right; width: 200px"
                  >立即预约</md-button
                ></a
              >
            </h3>
          </div>
        </md-card-header>
        <el-carousel height="278px" :autoplay="false">
          <el-carousel-item v-for="banner in cardList2" :key="banner.index">
            <img
              :src="banner"
              style="
                width: 100%;
                height: 100%;
                border-bottom-left-radius: 18px;
                border-bottom-right-radius: 18px;
              "
            />
          </el-carousel-item>
        </el-carousel>
      </md-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      time: 59 * 60 * 1000,
      cardList1: [
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/baoming1.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/baoming2.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/baoming3.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/baoming4.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/baoming5.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/baoming6.jpg",
      ],
      cardList2: [
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/canguan4.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/canguan2.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/canguan3.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/canguan1.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/canguan5.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/home/canguan6.jpg",
      ],
    };
  },
};
</script>

<style lang="less" scoped>
/deep/ .van-count-down {
  font-size: 32px;
  font-weight: 600;
  line-height: 60px;
  color: #fff;
}
/deep/ .van-button--normal {
  padding: 0;
}
/deep/ .van-notice-bar__left-icon,
.van-notice-bar__right-icon {
  color: red;
}
/deep/ .el-carousel__button {
  height: 5px;
}
/deep/ .el-carousel__indicators--outside button {
  background-color: #ff3d00;
}
/deep/ .el-carousel__container {
  height: 520px;
}
.van-swipe {
  cursor: auto;
}
.notice-swipe {
  height: 36px;
  line-height: 36px;
  font-size: 16px;
}
.van-notice-bar {
  color: #000;
  padding: 0 0 0 49px;
  background-color: #fff;
}
.van-swipe-item {
  text-align: center;
}
.b {
  color: red;
  margin-left: 30px;
}

.md-card.md-with-hover {
  cursor: auto;
}
.banner {
  margin-top: 64px;
  background: #f0f5ff;
}
.block-notfull {
  width: 1200px;
  padding: 0 0 20px 0;
  margin: 0 auto;
}
.block-full {
  width: 100%;
  margin: 0 auto;
}
.card {
  width: 1200px;
  height: 760px;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px 0;
  position: relative;
}
.card-endtime {
  width: 100%;
  height: 60px;
  line-height: 60px;
  text-align: center;
  position: absolute;
  color: #fff;
  bottom: 0;
  background: #ff3d00;
  border-bottom-left-radius: 18px;
  border-bottom-right-radius: 18px;
}
.card-hot-img {
  width: 590px;
  height: 328px;
  border-radius: 18px;
}
</style>